import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import { AppOrganizationDeleteConfirmDialog } from 'src/app/core/types/app-organization-delete-confirm-dialog.type';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-organization-delete-confirm-dialog',
    templateUrl: './organization-delete-confirm-dialog.component.html',
    styleUrls: ['./organization-delete-confirm-dialog.component.scss'],
    imports: [ModalTitleComponent, BaseFormModule]
})
export class OrganizationDeleteConfirmDialogComponent implements OnInit {
  organizationName: string;
  randomNum: number;
  typingText;

  constructor(
    private dialogRef: MatDialogRef<OrganizationDeleteConfirmDialogComponent>,
    private cd: ChangeDetectorRef,
    private loggerService: LoggerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.organizationName = data.itemName;
  }

  ngOnInit() {
    try {
      this.randomNum = Math.floor(1000 + Math.random() * 9000);
    } catch (error) {
      this.loggerService.logError(
        'app-organization-delete-confirm-dialog',
        error,
        EventTypes.systemManagement
      );
    }
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm(type: AppOrganizationDeleteConfirmDialog) {
    this.dialogRef.close(type);
  }
}
